export const COMMON_DATE_FORMAT = 'YYYY-MM-DD';
export const EditorToolbarOptions = [
    'blockType',
    'inline',
    'textAlign',
    'fontSize',
    'list',
    'link',
    'history',
    'colorPicker',
];
export const DEFAULT_FILE_NAME = 'attachment.pdf';
export const IMPORT_FAQ_PAGE_URL = 'https://debbie.zendesk.com/hc/da/articles/5325649493905-Import-af-sager';
export const CREATE_CREDITOR_FAQ_PAGE_URL = 'https://debbie.zendesk.com/hc/da/articles/5769628089105-Oprettelse-af-kreditorer';
export const PHONE_QUEUE_PAGE_URL = 'https://debbie.zendesk.com/hc/da/articles/8606348198545';
export const TEMPLATE_FAQ_PAGE_URL = 'https://debbie.zendesk.com/hc/da/articles/6340485062673-Oprettelse-af-skabeloner';
//# sourceMappingURL=constants.js.map